<template>
  <section v-if="tocLoaded"
           ref="sectionEl"
           class="section">
    <div class="columns is-mobile is-multiline">
      <div v-for="child in children"
           :key="child.id"
           class="column is-2-desktop is-3-tablet is-4-mobile">
        <card :item="child"
              :path="path"
              @click="select"/>
      </div>
    </div>
  </section>
  <section v-else class="loading">
    <loading-icon />
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import LoadingIcon from '@/components/common/LoadingIcon';
import Card from './NavigatorCard';
import { path } from '@/router/compositionObjects';

const SCROLL_KEY_PREFIX = 'chapter-scroll:';

function findScrollableAncestor(el) {
  let node = el;
  while (node && node !== document.documentElement) {
    const { overflowY } = window.getComputedStyle(node);
    if (/auto|scroll/.test(overflowY) && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentElement;
  }
  return document.scrollingElement;
}

export default {
  name: 'NavigatorViewer',
  components: {
    Card,
    LoadingIcon
  },
  computed: {
    ...mapState({
      tocLoaded: ({ content }) => content.toc.isLoaded
    }),
    ...mapGetters({
      children: 'content/tocChildren'
    }),
    ...path
  },
  watch: {
    $route(_to, from) {
      const section = this.$refs.sectionEl;
      if (!section) return;
      const scrollEl = findScrollableAncestor(section);
      if (scrollEl) sessionStorage.setItem(SCROLL_KEY_PREFIX + from.path, scrollEl.scrollTop);
    },
    tocLoaded: {
      immediate: true,
      handler(loaded) {
        if (loaded) this.$nextTick(this.restoreScroll);
      }
    }
  },
  methods: {
    ...mapActions({
      navigateToContentPath: 'content/navigateToContentPath'
    }),
    select(item) {
      this.navigateToContentPath({
        path: `${this.path}/${item.type}:${item.id}`
      });
    },
    restoreScroll() {
      if (!window.history.state?.forward) return;
      const section = this.$refs.sectionEl;
      if (!section) return;
      const saved = sessionStorage.getItem(SCROLL_KEY_PREFIX + this.$route.path);
      if (!saved) return;
      const pos = parseInt(saved, 10);
      requestAnimationFrame(() => {
        const scrollEl = findScrollableAncestor(section);
        if (scrollEl) scrollEl.scrollTop = pos;
      });
    }
  }
};
</script>

<style scoped>
.section {
  padding: 1rem;
  height: 100%;
  overflow: auto;
}
</style>
